<template>
  <div
    class="tables-settings layout"
    :class="{
      empty: isEmpty,
    }"
  >
    <div class="layout-title">Настройки</div>
    <m-confirm ref="confirm" mode="danger" />
    <div class="tables-settings__tabs">
      <c-tabs
        :items="[
          {
            label: 'Общие настройки',
            value: '/index.php?r=total-settings%2Findex',
            link: '/index.php?r=total-settings%2Findex',
          },
          { label: 'Настройки таблиц', value: 'tables-settings', disabled: !userHavePermissionForTablesSettings },
          { label: 'Автоматическое создание ведомостей', value: 'auto-creation-calc-sheets', disabled: !userHavePermissionForAutoCreationCalcSheets },
        ]"
        with-routing
      />
    </div>
    
    <condition-sidesheet ref="typeModal" :periods="periods" @submitted="modalIsSubmitted" @calculation-sheet-is-created="calculationSheetIsCreated" @delete-item="deleteItem" />

    <div v-if="!loading" class="tables-settings__content">
      <div v-if="inited" class="row tables-settings__actions">
        <div class="col col-12 col-md-8 col-lg-6 tables-settings__search">
          <c-select
            v-model="globalFilters.filial"
            type="select"
            label="Филиал"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.filial"
            :checkbox="true"
            :checkbox-value="globalFilters.filialReverse"
            :checkbox-type="'icon'"
            :checkbox-tooltip="{
              disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
              activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
              notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
            }"
            :useCustomColors="true"
            @checkboxChange="globalFilters.filialReverse = $event"
          />
          <c-button-2
            label="Применить"
            color="primary"
            @click="applyFilters"
          />
        </div>

        <div class="col col-12 col-md-4 col-lg-6 tables-settings__add">
          <c-button
            label="Добавить условие"
            :icon="{
              icon: 'plus',
              color: 'blue',
            }"
            @click="addTableSettings"
          />
        </div>
      </div>

      <div class="tables-settings__list">
        <tables-settings-table
          :inited="inited"
          :items="items"
          :empty="isEmpty"
          :sort-by="sortBy"
          :loading="loading"
          @nextPage="nextPage"
          @sort="sort"
          @remove="removeTableSettings"
          @edit-condition="editCondition"
        />
      </div>
    </div>

    <b-modal
        class="calculation-modal"
        id="create-user-employee-modal-success"
        v-model="active"
        size="custom-size"
        centered
        hide-footer
        hide-header
      >
        <div class="create-user-success-modal">
          <svg
            class="create-user-success-modal-close"
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="active = false"
          >
            <path
              d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
              fill="#8E9CBB"
            />
            <path
              d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
              fill="#8E9CBB"
            />
          </svg>
          Первая ведомость на период <b>{{ calculationSheet.period }}</b> создана.<br><br>
          Расчётная ведомость <a :href="'?r=redesign#/calculation-sheets/' + calculationSheet.id">№{{ calculationSheet.id }} {{ calculationSheet.dates }}</a>.
          <c-button class="close-action" size="large" label="Закрыть" @click="active = false" />
        </div>
    </b-modal>

    <transition name="fade">
      <display-shown-items-count
        v-if="!loading"
        :total-items-count="totalItemsCount"
        :shown-items-count="items.length"
      />
    </transition>

    <c-loader
      v-if="loading || loadingMore"
      label="Данные загружаются"
      :active="loading || loadingMore"
      :height="'400'"
    />

    <top-button root=".layout"></top-button>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CTabs from "@/components/tabs";
import CButton from "@/components/controls/button";
import CButton2 from "@/components/controls2/Button";
import CInput from "@/components/controls2/Input";
import CSelect from "@/components/controls2/Select";
import TopButton from "@/components/top-button";
import DisplayShownItemsCount from "@/components/display-shown-items-count";
import TablesSettingsTable from "./components/tables-settings-table";
import ConditionSidesheet from "./components/type-modal";
import ScrollableSidesheet from "@/components/scrollable-sidesheet";
import { onScrollEnd } from "@/helpers/events";
import Loader from "@/components/loader";
import Confirm from "@/components/modals/confirm-modal";

export default {
  name: "tables-settings-list",

  components: {
    CTabs,
    CButton,
    CInput,
    CSelect,
    TopButton,
    DisplayShownItemsCount,
    ConditionSidesheet,
    ScrollableSidesheet,

    "c-button-2": CButton2,
    "c-loader": Loader,
    "m-confirm": Confirm,

    TablesSettingsTable,
  },

  mounted() {
    const layout = document.querySelector(".layout");
    layout.addEventListener("scroll", this.handleLayoutScroll);
  },

  beforeDestroy() {
    const layout = document.querySelector(".layout");
    layout.removeEventListener("scroll", this.handleLayoutScroll);
  },

  computed: {
    ...mapState({
      totalItemsCount: (state) => state.autoCreationCalcSheets.totalItemsCount,
    }),
    ...mapGetters(["getUserPermissions"]),
    isEmpty() {
      return !this.items.length && !this.globalFilters.filial
    },
    userHavePermissionForAutoCreationCalcSheets() {
      return this.getUserPermissions.includes("automaticCalculationSheetControl")
    },
    userHavePermissionForTablesSettings() {
      return this.getUserPermissions.includes("columnSettingsControl")
    },
  },
  data() {
    return {
      page: 1,
      query: "",
      sortBy: "",
      desc: false,
      items: [],
      // isEmpty: false,
      isLastRequestEmpty: false,
      loading: false,
      loadingMore: false,
      inited: false,

      periods: [
        {
          value: 1,
          label: "1 день",
          description: "Ведомость будет создаваться в полночь текущего дня на следующий день."
        },
        {
          value: 2,
          label: "1 неделя",
          description: "Ведомость будет создаваться в полночь воскресенья на следующую неделю."
        },
        {
          value: 3,
          label: "2 недели",
          description: "Ведомость будет создаваться в полночь воскресенья на следующие 2 недели."
        },
        {
          value: 4,
          label: "Полмесяца",
          description: "Ведомость будет создаваться в полночь последнего дня месяца для периода с 1-го по 15-е, а в полночь 15-го будет создаваться ведомость с 16-го по 30(31)-е."
        },
        {
          value: 5,
          label: "1 месяц",
          description: "Ведомость будет создаваться в полночь последнего дня месяца на следующий месяц."
        },
        {
          value: 6,
          label: "Произвольный",
          description: "Ведомость будет создаваться один раз в указанное количество дней на следующий период из количества этих дней."
        },
      ],

      collections: {
        filial: [],
      },

      globalFilters: {
        filial: "",
        filialReverse: false,
      },

      calculationSheet: {
        id: "",
        period: "",
        dates: ""
      },

      active: false,
    };
  },
  async created() {
    this.loading = true;

    await this.$store.dispatch(`calculationSheets/getFilials`).then(res => {
      this.collections.filial = res.map(filial => ({
        value: filial.id,
        label: filial.name
      }))
    })

    await this.setFiltersFromQuery();

    await this.getList().then(() => {
      // this.isEmpty = !this.items.length;
      this.inited = true;
    });

    this.loading = false;
  },
  methods: {
    deleteItem(table) {
      this.$refs.confirm.open({
        title: "Удаление условия",
        text: `Условие для автоматического создания ведомости по филиалам: <b>${table.filialsNames} ${table.name}</b> будет удалено без возможности восстановления`,
        confirm: "Удалить",
        onConfirm: () => {
          this.$store
            .dispatch("autoCreationCalcSheets/removeTableSettings", {
              id: table.id,
            })
            .then(() => this.applyFilters());
            },
      });


      
    },
    calculationSheetIsCreated(data) {
      this.active = true;
      this.calculationSheet.period = this.periods.find(period => Number(period.value) === Number(data.period_type)).label
      this.calculationSheet.id = data.calculationSheet.id
      this.calculationSheet.dates = data.calculationSheet.date_from !== data.calculationSheet.date_to ? moment(data.calculationSheet.date_from,"YYYY-MM-DD").format("DD.MM.YYYY") + '-' + moment(data.calculationSheet.date_to,"YYYY-MM-DD").format("DD.MM.YYYY") : moment(data.calculationSheet.date_from,"YYYY-MM-DD").format("DD.MM.YYYY")
    },
    close() {
      this.active = false;
    },
    addTableSettings() {
      this.$refs.typeModal.open();
    },
    modalIsSubmitted() {
      this.applyFilters();
    },
    editCondition(condition) {
      this.$refs.typeModal.open(condition);
    },
    setQueryParams() {
      const { query } = this.$route;

      let allQueries = { ...query };

      if (this.globalFilters.filial) {
        allQueries = { ...allQueries, filial_value: this.globalFilters.filial.map(filial => (filial.value)).join(','), filial_search_type: this.globalFilters.filialReverse ? 1 : 0 };
      } else {
        allQueries = {}
      }

      if (JSON.stringify(query) !== JSON.stringify(allQueries)) {
        this.$router.replace({ name: "auto-creation-calc-sheets", query: allQueries });
      }
    },
    setFiltersFromQuery() {
      const { query } = this.$route;

      if (query.filial_value) {
        this.globalFilters.filial = [];

        query.filial_value.split(',').forEach(filialId => {
          let findedFilial = this.collections.filial.find(filial => Number(filial.value) === Number(filialId))

          if (findedFilial) this.globalFilters.filial.push(findedFilial)
        })

        this.globalFilters.filialReverse = query.filial_search_type === "1" ? false : true;
      }
    },
    getParams() {
      const params = {
        page: this.page,
        globalFilters: this.globalFilters
      };

      return params;
    },
    async getList() {
      // if (this.loading) return null;
      // if (this.isLastRequestEmpty) return null;
      // this.loading = true;

      return this.$store.dispatch("autoCreationCalcSheets/getList", this.getParams()).then((items) => {
        // if (!items.length < 50) this.isLastRequestEmpty = true;
        this.items = [...this.items, ...items];
        this.items = this.items.map(item => ({
          ...item,
          name: this.periods.find(period => Number(period.value) === Number(item.period_type)).label,
          filialsNames: item.filials.map(filial => (filial.filial_name)).join(', ')
        }))
        // this.loading = false;
      });
    },
    nextPage() {
      // if (this.isLastRequestEmpty) return;
      // if (!this.inited) return;
      // this.page += 1;
      // this.getList();
    },
    sort(column) {
      if (this.sortBy === column) {
        this.desc = !this.desc;
      } else {
        this.sortBy = column;
        this.desc = true;
      }
      this.applyFilters();
    },
    async applyFilters() {
      this.items = [];
      this.page = 1;
      this.isLastRequestEmpty = false;
      this.loading = false;
      this.setQueryParams();
      this.loading = true;
      await this.getList();
      this.loading = false;
    },
    removeTableSettings(table) {
      this.$store
        .dispatch("autoCreationCalcSheets/removeTableSettings", {
          id: table.id,
        })
        .then(() => this.applyFilters());
    },
    handleLayoutScroll() {
      onScrollEnd(async () => {
        if (this.loadingMore || this.loading) {
          return
        }
        
        if (this.items.length < this.totalItemsCount) {
          this.loadingMore = true;
          this.page++;
          await this.getList();
          setTimeout(() => {
            this.loadingMore = false;
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.tables-settings {
  /deep/ {
    .c-tabs-item-label {
      max-width: 335px;
    }
  }
  .layout-header {
    height: auto;
    min-height: 30px;
  }
  .layout-title {
    margin-bottom: 37px;
  }
  &__tabs {
    margin-bottom: 35px;
  }

  &__actions {
    margin-bottom: 20px;
  }

  &__add {
    display: flex;
    justify-content: flex-end;
    margin-left: auto;

    @include vp-767 {
      display: flex;
      justify-content: flex-end;
    }
  }

  &__search {
    display: flex;
    align-items: center;
    gap: 30px;

    [type="select"] {
      flex-grow: 1;
    }

    & /deep/ input::placeholder {
      font-style: italic;
    }

    @include vp-767 {
      flex-direction: column;

      [type="select"] {
        width: 100%;
      }

      button {
        width: 100%;
      }
    }
  }

  @include onlyStandartMobile {
    .layout-title {
      margin-bottom: 30px;
    }

    &__search {
      margin-bottom: 20px;
    }
    &__actions {
      margin-bottom: 36px;
    }
    // &__add {
    //   display: block;
    // }

    &.empty {
      .tables-settings__search {
        display: none;
      }
    }
  }
}

.create-user-success-modal {
  font-size: 13px;
  
  &-close {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 12px;
  }

  &-title {
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    margin: 0 0 25px;
  }

  &-description {
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 15px;

    &-bold {
      font-weight: 500;
    }
  }

  &-item {
    display: flex;
    align-items: center;

    &-name {
      color: #8E9CBB;
      font-size: 15px;
      line-height: 150%;
      min-width: 60px;
      margin-right: 5px;
    }

    &-value {
      font-size: 15px;
      font-weight: 500;
      line-height: 150%;
    }
  }

  &-additional-info {
    font-family: Fira Sans;
    font-size: 15px;
    line-height: 18px;

    &-link {
      cursor: pointer;
      text-decoration: none;
    }
  }

  &-actions {
    justify-content: flex-end;
    margin-top: 20px;
  }

  @media screen and (max-width: 700px) {
    padding-bottom: 32px;

    &-actions {
      position: absolute;
      left: 0;
    }
  }
}

.close-action {
  display: block;
  margin: 15px auto 0;
}
</style>
